import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ConnectivityService } from '../services/connectivity.service';

export const connectivityGuard: CanActivateFn = () => {
  const connectivity = inject(ConnectivityService);
  const router = inject(Router);

  if (connectivity.isOnline()) {
    return true;
  }

  if (!router.navigated) {
    return true;
  }

  connectivity.notifyOffline();
  return false;
};